<template>

    <kt-modal :visible="recordVisible" size="modal-lg" :title="recordTitle" @dismiss="onDismiss()">
        <template #body>
            <client-form v-model="record"></client-form>
        </template>

        <template #footer>
            <div class="row w-100">
                <div class="col-md-9 offset-md-3">
                    <div class="row">
                        <div :class="{ 'col-4': record.Id, 'col-6': !record.Id }">
                            <button @click="onDismiss()" class="btn btn-outline-secondary btn-sm form-control m-0 px-0">
                                <X size="16" />&nbsp;
                                Close
                            </button>
                        </div>
                        <div class="col-4" v-if="record.Id">
                            <button @click="deleteRecord()" class="btn btn-outline-danger btn-sm form-control m-0 px-0">
                                <Trash size="16"></Trash>&nbsp;
                                Delete
                            </button>
                        </div>
                        <div :class="{ 'col-4': record.Id, 'col-6': !record.Id }">
                            <button @click="saveRecord()" class="btn btn-outline-primary btn-sm form-control m-0 px-0">
                                <Save size="16" />&nbsp;
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </kt-modal>

</template>

<script setup>

import { ref, onMounted, onUpdated, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import Api from "@/services/ApiService";
import Alert from "@/services/Alert";
import Events from "@/services/Emitter";
import ClientForm from "@/components/Clients/ClientForm.vue";
import KtModal from "@/components/UI/KtModal.vue";
import { useClientStore } from "@/stores/ClientStore";

import { Save, X, Trash } from "lucide-vue-next"

const route = useRoute();
const router = useRouter();
const recordTitle = ref("New Customer");
const recordVisible = ref(true);

const props = defineProps({
    id: {
        type: [Number, String],
        default: null
    }
});

const emit = defineEmits(["cancel", "saved"]);

const newRecord = () => {
    return {
        Company: "",
        Code: "",
        Phone: "",
        ContactInformation: "",
        Status: 1
    };
};

const record = ref(newRecord());

const loadRecord = async (idValue) => {
    if (idValue && idValue !== "new") {
        let rec = await Api.loadClient(idValue);
        recordTitle.value = "Edit Customer";
        record.value = rec;
    } else {
        recordTitle.value = "New Customer";
        record.value = newRecord();
    }
};

const saveRecord = async () => {

    if (!record.value.Company)
    {
        Alert.notify({
            text: "Please enter a company name."
        });
        return;
    }

    if (!record.value.Code)
    {
        Alert.notify({
            text: "Please enter a company code."
        });
        return;
    }

    try {
        let pay = record.value;
        let rec = await Api.saveClient(pay);

        let clients = useClientStore();
        await clients.reload();

        // If used as global modal, emit event; otherwise navigate
        if (props.id !== null) {
            emit("saved");
        } 
        
        else {
            if (!pay.Id)
            {
                // redirect to the edit page
                Events.emit("redirect", "/client/edit/" + rec.Id);
            }

            else
            {
                // keep the user close to where they edited the record ...
                router.push("/client/edit/" + rec.Id);
            }
            
            // else, let the user close the modal
            // router.back();
        }
    } catch (error) {
        console.error("Save failed:", error);
    }
};

const deleteRecord = async () => {
    Alert.notify({
        text: "Deletion is currently disabled"
    });
};

const onDismiss = () => {

    // If used as global modal, emit event; otherwise navigate
    if (props.id !== null) {
        emit("cancel");
    } 
    
    else {
        // Events.emit("redirect", "/client/list");
        // router.back();
        router.push("/client/list");
    }
};

onMounted(async () => {
    // Use prop id if provided, otherwise use route params
    const idToLoad = props.id !== null ? props.id : route.params.id;
    await loadRecord(idToLoad);
});

// Watch for prop changes when used as global modal
watch(() => props.id, async (newId) => {
    if (newId !== null) {
        await loadRecord(newId);
    }
});

</script>